import Api from './Api'

export default {

    all() {
        return Api().get('/notes')
            .catch(error => { console.log(error.response) })
    },

    /*
    getFilter(value) {
        return Api().get('/tenders', {
            params: {
                organization: value.organization,
                active: value.active,
                important: value.important,
                status: value.status,
                from: value.from,
                to: value.to
            }
        })
        .catch(error => { console.log(error.response) })
    },
    */

    deleteItem(id) {
        return Api().delete(`/notes/${id}`)
                .catch(error => { console.log(error) })
    },

    addItem(value) {
        return Api().post(`/notes`, value)
                .catch(error => { console.log(error) })
    },

    editItem(id, value) {
        return Api().put(`/notes/${id}`, value)
                .catch(error => { console.log(error) })
    }

}